if (!customElements.get('mc-order-summary')) {
 customElements.define('mc-order-summary', class extends HTMLElement {
  connectedCallback() {
   this.scope = this.closest('product-info');
   if (!this.scope) return;
   this.controller = new AbortController();
   const update = () => {
    const price = this.scope.querySelector('[data-mc-unit-price]');
    const quantity = this.scope.querySelector('.quantity__input');
    const submit = this.scope.querySelector('button[name="add"]');
    const output = this.querySelector('[data-mc-total]');
    if (!price || !output) return;
    if (submit?.disabled) { output.textContent = '—'; return; }
    const total = Number(price.dataset.price) * Math.max(1, Number(quantity?.value) || 1) / 100;
    const currency = this.dataset.currency || 'KRW';
    output.textContent = currency === 'KRW'
     ? new Intl.NumberFormat('ko-KR', { maximumFractionDigits: 0 }).format(total) + this.dataset.won
     : new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency }).format(total);
   };
   this.scope.addEventListener('input', update, { signal: this.controller.signal });
   this.scope.addEventListener('change', update, { signal: this.controller.signal });
   this.observer = new MutationObserver(update);
   const price = this.scope.querySelector('[id^="price-"]');
   const submit = this.scope.querySelector('button[name="add"]');
   if (price) this.observer.observe(price, { childList: true, subtree: true });
   if (submit) this.observer.observe(submit, { attributes: true, attributeFilter: ['disabled'] });
   update();
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
 });
}
if (!customElements.get('mc-buy-now')) {
 customElements.define('mc-buy-now', class extends HTMLElement {
  connectedCallback() {
   const button = this.querySelector('button');
   const form = this.closest('form');
   const submit = form?.querySelector('button[name="add"]');
   if (!button || !form || !submit) return;
   this.controller = new AbortController();
   const sync = () => { button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true'; };
   this.observer = new MutationObserver(sync);
   this.observer.observe(submit, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
   button.addEventListener('click', () => {
    const variantId = form.querySelector('input[name="id"]');
    if (button.disabled || !variantId?.value || !form.reportValidity()) return;
    const redirect = form.querySelector('[data-mc-checkout-return]');
    if (!redirect) return;
    redirect.disabled = false;
    button.disabled = true;
    HTMLFormElement.prototype.submit.call(form);
   }, { signal: this.controller.signal });
   sync();
   button.hidden = false;
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
 });
}
if (!customElements.get('mc-product-description')) {
 customElements.define('mc-product-description', class extends HTMLElement {
  connectedCallback() {
   const containers = Array.from(this.querySelectorAll('div,p')).filter(el => !el.querySelector('div,p,table,img,video,a') && el.textContent.trim().startsWith('|'));
   containers.forEach(container => {
    const lines = container.innerHTML.split(/<br\s*\/?>|\n/gi).map(line => {
     const element = document.createElement('div'); element.innerHTML = line; return element.textContent.trim();
    }).filter(Boolean);
    if (!lines.length || lines.some(line => !line.startsWith('|'))) return;
    const table = document.createElement('table');
    table.className = 'mc-spec-table';
    const tbody = document.createElement('tbody');
    lines.forEach(line => {
     const cells = line.split('|'); cells.shift();
     if (!cells[cells.length - 1]?.trim()) cells.pop();
     if (cells.length < 2 || cells.every(cell => /^\s*:?-+:?\s*$/.test(cell))) return;
     const tr = document.createElement('tr');
     cells.forEach((cell, index) => {
      const td = document.createElement(index === 0 ? 'th' : 'td');
      if (index === 0) td.scope = 'row';
      td.textContent = cell.trim();
      tr.append(td);
     });
     tbody.append(tr);
    });
    if (!tbody.children.length) return;
    table.append(tbody);
    const wrap = document.createElement('div'); wrap.className = 'mc-spec-wrap'; wrap.append(table); container.replaceWith(wrap);
   });
  }
 });
}
